import _ from 'lodash';
import { SyntheticEvent, useState } from "react";
import ArrowLeft from "~frontend/components/icons/arrow-left";
import { Faq as FaqType } from '~types';
import "./styles.scss";

type FaqProps = {
  language: string;
  faqData: FaqType[];
  goPage: (event: SyntheticEvent<HTMLDivElement>) => void;
};

export default function FAQ({ language, faqData, goPage }: FaqProps) {
  const [openItem, setOpenItem] = useState<string>("how-to-play");

  const toggleItem = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <div className="faq_new">
      {faqData.map((item) => (
        <div
          key={item.id}
          className={`faq_item ${+openItem === +item.id ? "open" : ""}`}
        >
          <div
            className="faq_header"
            onClick={() => toggleItem(item.id)}
          >
            <h2 className="faq_title">{item?.data?.[language]?.title ?? item?.data?.['en']?.title}</h2>
            <div className="faq_icon">
              <ArrowLeft color="#A1A1AA" />
            </div>
          </div>
          <div
            className="faq_content"
            dangerouslySetInnerHTML={{
              __html: _.unescape(
                _.result(
                  item.data,
                  `${language}.text`,
                  item?.data?.en?.text,
                ),
              ),
            }}
            onClick={goPage}
          />
        </div>
      ))}
    </div>
  );
}
